import { gsap } from 'gsap'
// import { ScrollTrigger } from 'gsap/ScrollTrigger'
import lottie from 'lottie-web'
import { CONTENT_Y_DISTANCE } from './gsap-shared'

const animateOpenPositions = {
    $trigger: $('.js-section-open-positions'),
    $titles: $('.js-open-positions-title'),
    $floors: $('.js-building-floor'),
    $buildingContainer: $('.js-building-container'),
    $openPositionsWrap: $('.js-open-positions-outer-wrap'),
    tabContents: gsap.utils.toArray('.js-open-positions-tab-content'),
    $defaultTabContent: $('.js-open-positions-tab-content.default'),
    lottieWrappers: gsap.utils.toArray('.js-lottie-floor'),
    lottieFloors: null,
    currentlyMobileLandscape: null,
    animateBuildingInView: gsap.timeline(),
    tabsContentAdditionalHeight: 130,

    init: function () {
        let _this = this

        // Check if on init we are in mobile landscape
        _this.currentlyInMobileLandscape = _this.isInMobileLandscape()

        // Init and store lotties
        _this.lottieFloors = _this.lottieWrappers.map(floor => {
            const lottieObj = _this.initLottie(floor)
            lottieObj.addEventListener('data_ready', () =>
                $(floor).addClass('lottie-loaded')
            )
            return lottieObj
        })

        if (_this.$trigger.length) {
            //Set all tab contents to be hidden on init
            gsap.set(_this.tabContents, {
                x: CONTENT_Y_DISTANCE,
                opacity: 0,
            })

            //Animate into view the default tab content
            if (!_this.isInMobileLandscape()) {
                gsap.set(_this.tabContents[0], {
                    x: 0,
                    opacity: 1,
                })
            }

            $('.js-back-to-building').on('click', () => {
                _this.animateBuildingInView
                    .to(_this.tabContents, {
                        duration: 0.5,
                        x: CONTENT_Y_DISTANCE,
                        opacity: 0,
                        overwrite: true,
                    })
                    .to(_this.$buildingContainer, {
                        duration: 1,
                        x: 0,
                        opacity: 1,
                        overwrite: true,
                    })

                if (!_this.$openPositionsWrap.hasClass('building-is-over')) {
                    setTimeout(() => {
                        _this.$openPositionsWrap.addClass('building-is-over')
                    }, 300)
                }
                //remove .is-active class from previous active tab
                _this.$titles.removeClass('is-active')
                //remove .is-active class from previous active floor
                _this.$floors.removeClass('is-active')

                // remove is-active class from containers
                _this.tabContents.forEach(element => {
                    $(element).removeClass('is-active')
                })

                _this.$defaultTabContent.addClass('is-active')

                _this.$openPositionsWrap.removeAttr('style')

                // pause playing lottie animation
                _this.pauseAllAnimations()
            })

            $(window).on('load resize', () => {
                // Reset container height
                _this.$openPositionsWrap.removeAttr('style')
                // Adjust the height of the container in order to fit the absolute text
                _this.adjustTabsContainerHeight()
                if (
                    _this.isInMobileLandscape() &&
                    _this.currentlyInMobileLandscape === false
                ) {
                    // Update current resolution state
                    _this.currentlyInMobileLandscape = true

                    // _this.tabContents.css('opacity', '0')
                    if ($('.js-open-positions-title').hasClass('is-active')) {
                        _this.$buildingContainer.css('opacity', '0')
                    }

                    // If the building is still in a default state, we animate the default textbox out
                    if (!$('.js-open-positions-title').hasClass('is-active')) {
                        gsap.set(_this.tabContents[0], {
                            x: CONTENT_Y_DISTANCE,
                            opacity: 0,
                        })
                    }
                } else if (
                    _this.isInMobileLandscape() === false &&
                    _this.currentlyInMobileLandscape === true
                ) {
                    // Update current resolution state
                    _this.currentlyInMobileLandscape = false

                    // Make the building visible again in case it was hidden
                    _this.$buildingContainer.removeAttr('style')

                    // If the building is still in a default state, we animate the default textbox in
                    if (!$('.js-open-positions-title').hasClass('is-active')) {
                        gsap.set(_this.tabContents[0], {
                            x: 0,
                            opacity: 1,
                        })
                    }
                }
            })

            // Clicking on titles
            _this.$titles.on('click', e => {
                let animationTimeline = gsap.timeline()
                let landscapeAnimation = gsap.timeline()
                let clickedTab = `#${$(e.currentTarget).attr('id')}`
                let clickedTabFloor = `${clickedTab}-floor`
                let clickedTabContent = `${clickedTab}-content`
                let clickedTabLottie = `${$(e.currentTarget).attr('id')}-lottie`

                // remove .is-active class from previous active tab
                $('.js-open-positions-title').removeClass('is-active')
                //set .is-active class to the newly clicked tab
                $(clickedTab).addClass('is-active')

                //remove .is-active class from previous active floor
                $('.js-building-floor').removeClass('is-active')
                //set .is-active class to the corresponding floor
                $(clickedTabFloor).addClass('is-active')

                $('.js-open-positions-tab-content').removeClass('is-active')
                $(clickedTabContent).addClass('is-active')

                //pause all ongoing animations
                _this.pauseAllAnimations()
                //play only the animation corresponding to the clicked tab
                _this.playAnimation(clickedTabLottie)

                //animate the content box
                animationTimeline
                    .to(_this.tabContents, {
                        duration: 0.5,
                        x: CONTENT_Y_DISTANCE,
                        opacity: 0,
                        overwrite: true,
                    })
                    .to(clickedTabContent, {
                        duration: 1,
                        x: 0,
                        opacity: 1,
                        overwrite: true,
                    })

                setTimeout(() => {
                    _this.$openPositionsWrap.removeClass('building-is-over')
                }, 300)
                // Adjust the height of the container in order to fit the absolute text
                _this.adjustTabsContainerHeight()
                if (_this.isInMobileLandscape()) {
                    // Hide the building
                    landscapeAnimation.to(_this.$buildingContainer, {
                        duration: 0.5,
                        x: CONTENT_Y_DISTANCE,
                        opacity: 0,
                        overwrite: true,
                    })
                }
            })

            // Clicking on floors
            _this.$floors.on('click', e => {
                let clickedFloor = `#${$(e.currentTarget).attr('id')}`
                let clickedTab = clickedFloor.replace('-floor', '')

                $(clickedTab).trigger('click')
            })

            // Hovering the title
            _this.$titles.on('mouseenter', e => {
                if (this.isMobile()) {
                    return
                }
                let clickedTab = `#${$(e.currentTarget).attr('id')}`
                let clickedTabFloor = `${clickedTab}-floor`
                $(clickedTabFloor).hide()
            })
            _this.$titles.on('mouseleave', e => {
                let clickedTab = `#${$(e.currentTarget).attr('id')}`
                let clickedTabFloor = `${clickedTab}-floor`
                $(clickedTabFloor).show()
            })

            // Hovering the floors
            _this.$floors.on('mouseenter', e => {
                if (this.isMobile()) {
                    return
                }
                let clickedFloor = `#${$(e.currentTarget).attr('id')}`
                let clickedTab = clickedFloor.replace('-floor', '')
                $(clickedTab).addClass('hover')
            })
            _this.$floors.on('mouseleave', e => {
                let clickedFloor = `#${$(e.currentTarget).attr('id')}`
                let clickedTab = clickedFloor.replace('-floor', '')
                $(clickedTab).removeClass('hover')
            })
        }
    },
    playAnimation: function (floor) {
        this.lottieFloors
            .find(animation => {
                return animation.name === floor
            })
            .play()
    },
    pauseAllAnimations: function () {
        this.lottieFloors.map(animation => animation.pause())
    },
    initLottie: function (floor) {
        const { name, path } = floor.dataset
        return lottie.loadAnimation({
            container: floor,
            renderer: 'svg',
            name,
            path,
            rendererSettings: {
                preserveAspectRatio: 'xMidYMax meet',
                progressiveLoad: true,
            },
            autoplay: false,
        })
    },
    isInMobileLandscape: function () {
        let result =
            $(window).width() >= 640 &&
            $(window).width() <= 1024 &&
            $(window).width() > $(window).height()
        return result
    },
    adjustTabsContainerHeight: function () {
        let _this = this
        let currentChildHeight =
            $('.js-open-positions-tab-content.is-active').height() +
            _this.tabsContentAdditionalHeight

        _this.$openPositionsWrap.removeAttr('style')
        _this.$openPositionsWrap.css('min-height', currentChildHeight)
    },
    isMobile: function () {
        return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
    },
}

animateOpenPositions.init()
